import { disabledFlags$ } from '../../../NonReact/common/RxJS/DisabledFlagsState'

export const useDisableFlags = (flagName: string, flagValue: boolean): void => {
    disabledFlags$.announce({ [flagName]: flagValue })
}
